module.exports = __webpack_public_path__ + "img/f6a96b342cc9d9cbca8f820f17c6d249.85b220a9.png";